import { get, type RequestOptions } from '@/api/client';
import type {
  PatientCommsResponse,
  PatientFormsResponse,
  PatientProfile,
  PatientsSearchResponse,
  ProducerOutputs,
} from './types';

export const patientsApi = {
  search: (q?: string, sort?: string, options?: RequestOptions) =>
    get<PatientsSearchResponse>(
      '/api/patients/search',
      {
        ...(q ? { q } : {}),
        ...(sort ? { sort } : {}),
      },
      options,
    ),

  getProfile: (id: number, options?: RequestOptions) =>
    get<PatientProfile>(`/api/patients/${id}`, undefined, options),

  getProducerOutputs: (id: number, options?: RequestOptions) =>
    get<ProducerOutputs>(`/api/patients/${id}/profile-producer-outputs`, undefined, options),

  getCommunications: (
    id: number,
    filters?: { lane?: string; channel?: string; page?: number },
    options?: RequestOptions,
  ) =>
    get<PatientCommsResponse>(`/api/patients/${id}/communications`, filters ?? {}, options),

  getForms: (id: number, options?: RequestOptions) =>
    get<PatientFormsResponse>(`/api/patients/${id}/forms`, undefined, options),
};
